export default __webpack_public_path__ + "static/media/login-image.392329e0.jpg";